var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRulerFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.707 6.293l-5-5a.999.999 0 00-1.414 0L14 3.586l2.699 2.708-1.416 1.412L12.585 5 11 6.586l1.707 1.706-1.414 1.415L9.586 8 8 9.586l2.707 2.707-1.414 1.414L6.586 11 5 12.586l1.706 1.706-1.414 1.414L3.586 14l-2.293 2.293a.999.999 0 000 1.414l5 5a.997.997 0 001.414 0l15-15a.999.999 0 000-1.414z"
  })));
}
export default SvgRulerFill;